/**
 * @desc undefined
 */
import { PageBankEntity, BankQuery } from '@eastcoal/api/finance/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryBankPageParameter = BankQuery

const method = 'GET'
const url = '/finance/bank/page'

export const queryBankPageApi = (
  params?: QueryBankPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageBankEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryBankPageApi.method = method
queryBankPageApi.url = url
